import { ConfigProviderProps } from 'antd';

import dayjs from 'dayjs';
import { makeWhiteLabel } from 'lib/helpers/WhiteLabel.helper';

const wl = makeWhiteLabel();
const year = dayjs().year();

export const COPYRIGHT = `${wl.name} ©${year}` as const;
export const DATE_SERVER_FORMAT = 'YYYY-MM-DD' as const;
export const DATE_CLIENT_FORMAT = 'DD/MM/YYYY' as const;
export const TIME_SERVER_FORMAT = 'HH:mm:ss' as const;
export const DATETIME_SERVER_FORMAT = `${DATE_SERVER_FORMAT} ${TIME_SERVER_FORMAT}` as const;
export const DATETIME_CLIENT_FORMAT = `${DATE_CLIENT_FORMAT} HH:mm` as const;

export const GCONDO_BROKER_TOKEN_COLOR_PRIMARY = '#08ac9e' as const;

export const GCONDO_BROKER_THEME: ConfigProviderProps['theme'] = {
    token: {
        colorPrimary: GCONDO_BROKER_TOKEN_COLOR_PRIMARY,
        colorInfo: GCONDO_BROKER_TOKEN_COLOR_PRIMARY,
    },
    cssVar: { key: 'gcondo-broker-theme' },
};